import { render, staticRenderFns } from "./OpcionesImpresion.vue?vue&type=template&id=86048eda&scoped=true"
import script from "./OpcionesImpresion.vue?vue&type=script&lang=js"
export * from "./OpcionesImpresion.vue?vue&type=script&lang=js"
import style0 from "./OpcionesImpresion.vue?vue&type=style&index=0&id=86048eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86048eda",
  null
  
)

export default component.exports